// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  background: #fff;
  border-radius: 10px;
  width: 650px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.modal-search-input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
  padding: 6px 8px 6px 18px;
}

.modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
}

.modal-body {
  padding: 10px;
  overflow-y: auto;
}

.chat-group {
  margin-top: 20px;
  margin-left: 16px;
}

.chat-group-title {
  font-size: 12px;
  font-weight: bold;
  color: #777;
  margin: 5px 0;
}

.chat-title-text{
  font-size: 13px;
}

.chat-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 0px;
}

.chat-item:hover {
  background: #f5f6f7;
}
`, "",{"version":3,"sources":["webpack://./src/pages/layout/SearchChatModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0,0,0,0.3);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-container {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  width: 650px;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-search-input {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 14px;\r\n  padding: 6px 8px 6px 18px;\r\n}\r\n\r\n.modal-close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #666;\r\n}\r\n\r\n.modal-body {\r\n  padding: 10px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.chat-group {\r\n  margin-top: 20px;\r\n  margin-left: 16px;\r\n}\r\n\r\n.chat-group-title {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  color: #777;\r\n  margin: 5px 0;\r\n}\r\n\r\n.chat-title-text{\r\n  font-size: 13px;\r\n}\r\n\r\n.chat-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  margin-left: 0px;\r\n}\r\n\r\n.chat-item:hover {\r\n  background: #f5f6f7;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
